<template>
  <div id="page-product-details">
    <facility-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Facility Create"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import FacilityForm from "@/views/pages/facilities/FacilityForm";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "FacilityCreate",
  components: {
    FacilityForm,
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const references = [
        'ClassOfBusiness_FK',
        'FacilityType_FK',
        'CompanyLeadInsurer_FK',
        'TerritoryRiskLocation_FK',
        'TerritoryInsuredDomicile_FK',
        'TerritoryTerritorialLimit_FK',
        'CompanyLossAdjuster_FK',
      ];

      const multiReferences = [
        {
          array: 'managers',
          key: 'CompanyFacilityManager_FK',
          dates: [
              'InceptionDate',
              'ExpiryDate',
          ]
        },
        {
          array: 'coverholders',
          key: 'CompanyCoverholder_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ],
        },
        {
          array: 'placing_brokers',
          key: 'CompanyPlacingBroker_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ],
        },
        {
          array: 'intermediary',
          key: 'CompanyIntermediary_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ]
        },
      ];

      const dates = [
        'InceptionDate',
        'ExpiryDate',
        'ProfitCommissionDate',
        'BARefDate',
      ]

      this.setDates(dates, params);
      this.setMultiReferences(multiReferences, params);
      this.setReferences(references, params);

      return params;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async create() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      delete params.id;

      try {
        const {data} = await this.$api.facilities.create(params);
        this.notifySuccess('Facility created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Facility failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
